import React, { useEffect } from 'react';
import MainApp from './Components/MainApp';
import Login from './Pages/Login';
import CrispChat from './Components/CrispChat';
import NoInternetScreen from './Components/NoInternetScreen';
import useNetworkStatus from './Hooks/useNetworkStatus';
import './Styles/all-styles.js';

window.baseDomain = process.env.REACT_APP_BASE_DOMAIN;
window.viewMode = 'full-screen';
window.isProduction = process.env.NODE_ENV === 'production';

const App = () => {
  const loginDone = localStorage.getItem('loginSuccessful') === 'true';
  const isOnline = useNetworkStatus();

  useEffect(() => {
    if (!localStorage.getItem('preferredLanguage')) {
      localStorage.setItem('preferredLanguage', 'nl');
    }
  }, []);

  if (!isOnline) {
    return <NoInternetScreen />;
  }

  if (!loginDone) {
    return <Login />;
  } else {
    return (
      <>
        <MainApp />
        <CrispChat />
      </>
    );
  }
};

export default App;
